import { zones } from './zones';
import { fuites } from './fuites';
import { techniques } from './techniques';
import { assurance } from './assurance';
import { pagesDe } from './de';
import { pagesEn } from './en';
import { techniquesDe } from './de-techniques';
import { techniquesEn } from './en-techniques';

const translated = [...pagesDe, ...techniquesDe, ...pagesEn, ...techniquesEn];

export const pages = [...zones, ...fuites, ...techniques, ...assurance, ...translated];

export const pageByPath = Object.fromEntries(pages.map((p) => [p.path, p]));

// Versions linguistiques, regroupées par page française :
// { '/degat-des-eaux': { fr: '/degat-des-eaux', de: '/de/wasserschaden', en: '/en/water-damage' } }
const translations = {
  '/contact': { fr: '/contact', de: '/de/kontakt', en: '/en/contact' },
};
for (const p of translated) {
  translations[p.translationOf] = translations[p.translationOf] || { fr: p.translationOf };
  translations[p.translationOf][p.lang] = p.path;
}

const translationOfPath = Object.fromEntries(
  Object.values(translations).flatMap((t) => Object.values(t).map((p) => [p, t.fr]))
);

export const alternatesOf = (path) => translations[translationOfPath[path] || path] || null;

// Langue d'une URL : préfixe /de/ ou /en/, sinon français.
export const langOfPath = (path) => {
  const m = path.match(/^\/(de|en)(\/|$)/);
  return m ? m[1] : 'fr';
};
